import { useTranslation } from 'react-i18next'

import { FieldGroup, FieldGroupHeader, FieldsTable } from '@/components/layout/field-table'
import { TabCard } from '@/components/layout/tab-card'
import { Skeleton } from '@/components/ui/skeleton'
import { Typography } from '@/components/ui/typography'

import { SKELETON_GROUPS } from './general-information.constants'
import * as S from './general-information.styled'

export const GeneralInformationSkeletonBody = () => {
  const { t } = useTranslation(['clients'])

  return (
    <FieldsTable>
      {SKELETON_GROUPS.map(({ fields, group }) => (
        <FieldGroup key={group}>
          <FieldGroupHeader>{t(`clients:generalInformation.groups.${group}`)}</FieldGroupHeader>
          {group === 'personalAndContact' && (
            <S.PhotoRow>
              <S.LabelWrapper>
                <Typography size="text-medium" color="primary500" as="span" whiteSpace="nowrap">
                  {t('clients:generalInformation.photo.label')}
                </Typography>
              </S.LabelWrapper>
              <Skeleton variant="rectangular" width="10rem" height="10rem" />
            </S.PhotoRow>
          )}
          {fields.map((field) => (
            <S.FieldRow key={field}>
              <S.LabelWrapper>
                <Typography size="text-medium" color="primary500" as="span" whiteSpace="nowrap">
                  {t(`clients:generalInformation.${field}.label`)}
                </Typography>
              </S.LabelWrapper>
              <Skeleton variant="text" width="16rem" height="1.4rem" />
            </S.FieldRow>
          ))}
        </FieldGroup>
      ))}
    </FieldsTable>
  )
}

export const GeneralInformationSkeleton = () => {
  const { t } = useTranslation(['clients'])

  return (
    <TabCard
      actions={<Skeleton variant="rectangular" width="7rem" height="3rem" />}
      title={t('clients:generalInformation.title')}
    >
      <GeneralInformationSkeletonBody />
    </TabCard>
  )
}
